import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faClone, faArrowRightFromBracket, faEllipsisVertical, faTrash, faQrcode, faStar, faDownload, faUsers, faPenToSquare, faCalendar, faClock, faLocationDot, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';
import useApiFetch from '../../ApiFetch';
import { HtmlEditor } from '../shared/htmlEditor';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TimeFromDate from '../shared/TimeFromDate';
import DownloadCSV from '../shared/DownloadCSV';
import { CSVLink, CSVDownload } from "react-csv";
import DataTable from 'react-data-table-component';
import {
    UncontrolledDropdown, DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';

export default function EventRegistrationRowGuest(props) {
    const { eventGuest, passesUpdated, guestDeleted } = props;
    const apiFetch = useApiFetch();

    const [localEventGuest, setLocalEventGuest] = useState(eventGuest);
    const [eventPass, setEventPass] = useState(eventGuest?.eventPass);

    const [loading, setLoading] = useState(false);
    const [registrations, setRegistrations] = useState([]);

    const [modal, setModal] = useState(false);

    const [validated, setValidated] = useState(false);

    const modalToggle = () => {
        if (!modal) {
            //getData();
        }
        setModal(!modal);
        setValidated(false);
    };

    useEffect(() => {
        setEventPass(eventGuest?.eventPass);
        setLocalEventGuest(eventGuest);
    }, [eventGuest]);
    const deleteGuest = async () => {
        modalToggle();
    };
    const confirmDelete = async () => {
        await apiFetch.delete('/api/registration/guest/' + encodeURIComponent(eventGuest.id))
            .then(resp => {

                if (guestDeleted)
                    guestDeleted(eventGuest)

                modalToggle();

            });
    };
    const togglePass = async (active) => {
        if ((eventPass ?? eventGuest?.eventPass)) {
            const updatedPass = { ...(eventPass ?? eventGuest?.eventPass), active: !(eventPass ?? eventGuest?.eventPass).active };
            // we have an eventPass record that we have to update based on 'active'
            await apiFetch.put('/api/registration/pass/' + encodeURIComponent((eventPass ?? eventGuest?.eventPass).id), updatedPass)
                .then(resp => {
                    if (resp.data) {
                        setEventPass(resp.data);
                    }
                })
                .catch(err => {
                    //    if (err.response && err.response && err.response.data === "Invalid Code")
                    //        setInvalidCode(true);
                });
        }
        else {
            await apiFetch.get('/api/registration/' + encodeURIComponent(eventGuest.registrationId) + '/pass/')
                .then(resp => {
                    if (resp.data) {
                        let thisPass = resp.data.find(p => p.registrationId === eventGuest.registrationId && p.eventGuestId === null);
                        setEventPass(thisPass);

                        let passes = resp.data;
                        updatedPasses(passes);
                        //Now get all the guests in the registration and assign passess to them
                        //r.eventGuests.forEach((eg, ii) => {
                        //    eg.eventPass = passes.find(p => p.registrationId === r.id && p.eventGuestId === eg.id);
                        //});


                    }
                })
                .catch(err => {
                    //    if (err.response && err.response && err.response.data === "Invalid Code")
                    //        setInvalidCode(true);
                });
        }
    };

    const updatedPasses = (passes) => {
        if (passesUpdated)
            passesUpdated(passes);
    };

    return (
        <>
            <tr className="table-default text-secondary">
                <td className="">
                    <div className="d-flex justify-content-between align-items-center">
                        <UncontrolledDropdown className="div">
                            <DropdownToggle data-toggle="dropdown" tag="span">
                                <FontAwesomeIcon icon={faEllipsisVertical} style={{ cursor: 'pointer' }} />
                            </DropdownToggle>
                            <DropdownMenu flip tag="ul">
                                <DropdownItem onClick={deleteGuest}>
                                    <FontAwesomeIcon icon={faTrash} className="me-2 opacity-50 text-danger" fixedWidth /> Delete Guest
                                </DropdownItem>
                                <DropdownItem onClick={() => { togglePass(!(eventPass ?? eventGuest?.eventPass)?.active) }}>
                                    <FontAwesomeIcon icon={faQrcode} className={`me-2 opacity-50 ${(eventPass ?? eventGuest?.eventPass)?.active ? 'text-danger' : 'text-success'}`} fixedWidth /> {(eventPass ?? eventGuest?.eventPass)?.active ? 'Disable' : 'Enable'} Pass
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </td>
                <td className="text-secondary-emphasis">
                    <div className="d-flex justify-content-between align-items-center">
                        {eventGuest.email ?? <>&nbsp;</>}
                        {(eventPass || eventGuest.eventPass) &&
                            <FontAwesomeIcon icon={faQrcode} className={`${(eventPass ?? eventGuest.eventPass).active ? 'text-body-emphasis' : 'text-danger'}`} />
                        }
                    </div>
                </td>
                <td className="text-secondary-emphasis">{eventGuest.firstName}</td>
                <td className="text-secondary-emphasis">{eventGuest.lastName}</td>
                <td className="text-secondary-emphasis">{eventGuest.company}</td>
                <td className="text-secondary-emphasis">{eventGuest.phone}</td>
                <td className="text-secondary-emphasis text-center"><TimeFromDate date={eventGuest.dateCreated} /></td>
            </tr>
            <Modal isOpen={modal} toggle={modalToggle} size="lg" fade={true} backdrop="static">
                <ModalHeader className="bg-danger text-white">
                    <FontAwesomeIcon icon={faTrash} className="pe-2" />Delete Guest?
                </ModalHeader>
                <ModalBody>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-3 text-center">
                                <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger display-1" />
                            </div>
                            <div className="col-9">
                                <h5 className="fw-bold">Are you sure you want to delete this guest?</h5>
                                <p className="text-muted">This action is <strong>permanent</strong> and cannot be undone.</p>

                                <p className="text-center">
                                    <span className="pt-2 mb-0 h2">{eventGuest.firstName} {eventGuest.lastName}</span><br/>
                                    {eventGuest.company ? <h3 className="lead">{eventGuest.company}</h3> : null}
                                    {eventGuest.email ? <div className="py-0">{eventGuest.email}</div> : null}
                                    {eventGuest.phone ? <div className="py-0">{eventGuest.phone}</div> : null}
                                </p>
                            </div>
                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-secondary" onClick={modalToggle}>
                        Cancel
                    </button>
                    <button type="button" className="btn btn-danger" onClick={confirmDelete}>
                        <FontAwesomeIcon icon={faTrash} className="me-1" />
                        Delete
                    </button>
                </ModalFooter>
            </Modal>
        </>
    );
};
